import restCrudActions from '../../../np-crud/store/restCrudActions';
import config from '../../../../config/config';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'dependent_settings',
    pluginName: 'SETTINGS',
    entityName: 'DEVICE_DEPENDENT_SETTING',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true
});

// Fetch DependentSetting action creators
export const fetchDependentSettingInit = () => {
    return crudActions.fetchInit();
};
export const fetchDependentSettingStart = () => {
    return crudActions.fetchStart();
};
export const fetchDependentSettingSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchDependentSettingFail = () => {
    return crudActions.fetchFail();
};
export const fetchDependentSettingCount = (filter, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchDependentSettingStart());
        try {
            let countRes = await rest.post("dependent-settings/count", filter, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchDependentSettingSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchDependentSettingFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch dependent setting."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchDependentSettingFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch dependent setting."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};


export const fetchDependentSetting = (filter, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchDependentSettingStart());
        try {
            let listRes = await rest.post("dependent-settings/list", filter, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchDependentSettingSuccess(filter.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchDependentSettingFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchDependentSettingFail());

            return { data: [] };
        }
    }
};

// Create DependentSetting  action creators
export const createDependentSettingInit = () => {
    return crudActions.createInit();
};
export const createDependentSettingStart = () => {
    return crudActions.createStart();
};
export const createDependentSettingSuccess = createdDependentSetting => {
    return crudActions.createSuccess(createdDependentSetting);
};
export const createDependentSettingFail = error => {
    return crudActions.createFail(error);
};

export const createDependentSetting = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createDependentSettingStart());
        try {
            let res = await rest.post('/dependent-settings/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createDependentSettingSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created dependent setting.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createDependentSettingFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create dependent setting."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create dependent setting."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createDependentSettingFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Delete DependentSetting  action creators
export const bulkDeleteDependentSettingInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteDependentSettingStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteDependentSettingSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteDependentSettingFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteDependentSetting = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteDependentSettingStart());
        try {
            let res = await rest.post('/dependent-settings/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteDependentSettingSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted dependent setting.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteDependentSettingFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete dependent setting."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete dependent setting."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteDependentSettingFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit DependentSetting  action creators
export const editDependentSettingInit = () => {
    return crudActions.editInit();
};
export const editDependentSettingStart = () => {
    return crudActions.editStart();
};
export const editDependentSettingSuccess = editedDependentSetting => {
    return crudActions.editSuccess(editedDependentSetting);
};
export const editDependentSettingFail = error => {
    return crudActions.editFail(error);
};

export const editDependentSetting = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editDependentSettingStart());
        try {
            let res = await rest.post('/dependent-settings/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editDependentSettingSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated dependent setting.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editDependentSettingFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit dependent setting."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit dependent setting."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editDependentSettingFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Load DependentSetting action creators
export const loadDependentSettingInit = () => {
    return crudActions.loadInit();
};
export const loadDependentSettingStart = () => {
    return crudActions.loadStart();
};
export const loadDependentSettingSuccess = loadedDependentSetting => {
    return crudActions.loadSuccess(loadedDependentSetting);
};
export const loadDependentSettingFail = error => {
    return crudActions.loadFail(error);
};
export const loadDependentSetting = (loadData, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadData, options);
    };
};

// Custom functions 
export const downloadFile = (type, activeCustomerID) => {
    let token = localStorage.getItem('SESSION');

    return async (dispatch) => {
        return fetch(`${config.backend_domain}:${config.backend_port}/dependent-settings/export_all?Type=${type}&ActiveCustomerID=${activeCustomerID.ActiveCustomerID}&Token=${token}`, {
            method: "GET",
        }).then(async response => {
            if (response.status === 200) {
                return response.blob();
            }
            return null;
        });
    }
};

export const exportSetting = (ID, activeCustomerID) => {
    let token = localStorage.getItem('SESSION');

    return async (dispatch) => {
        return fetch(`${config.backend_domain}:${config.backend_port}/dependent-settings/export?ID=${ID}&ActiveCustomerID=${activeCustomerID.ActiveCustomerID}&Token=${token}`, {
            method: "GET",
        }).then(async response => {
            if (response.status === 200) {
                return response.blob();
            }
            return null;
        });
    };
};

export const DeviceDependentSettingsUploadStart = () => {
    return {
        type: 'UPLOAD_DEVICE_DEPENDENT_SETTING_START'
    };
};
export const DeviceDependentSettingsUploadSuccess = () => {
    return {
        type: 'UPLOAD_DEVICE_DEPENDENT_SETTING_SUCCESS'
    };
};
export const DeviceDependentSettingsUploadFail = () => {
    return {
        type: 'UPLOAD_DEVICE_DEPENDENT_SETTING_FAIL'
    };
};
export const uploadProgress = (data) => {
    return {
        type: 'LOGOS|PROGRESS',
        progress: data.progress,
        loadSize: data.loadSize,
        maxSize: data.maxSize,
        snackStart: data.snackStart

    };
};

export const DeviceDependentSettingsUpload = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            const config = {
                onUploadProgress: progressEvent => {
                    dispatch(uploadProgress({ progress: Math.round((progressEvent.loaded * 100) / data.get('File').size), loadSize: Math.round((progressEvent.loaded / 1048576)), maxSize: Math.round((progressEvent.total / 1048576)), snackStart: true }));
                }
            }
            dispatch(DeviceDependentSettingsUploadStart());
            let res = await rest.post('dependent-settings/import', data, config);
            if (res.data.status === 200) {
                dispatch(uploadProgress({ progress: 100, loadSize: 0, maxSize: 0, snackStart: false }));
                dispatch(DeviceDependentSettingsUploadSuccess());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : 'Upload was successful.'}`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.status === 200;
            }
            else {
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }));
                dispatch(DeviceDependentSettingsUploadFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }));
            dispatch(DeviceDependentSettingsUploadFail());
            snackActions.snackBar({
                message: `${error && error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
};

export const clearState = () => {
    return async dispatch => {
        dispatch({ type: "CORE|DEVICE_DEPENDENT_SETTING|CLEAR" });
    }
};